import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { classNameParserCore } from "../../coreFunctions/classNameParserCore/classNameParserCore";
import "./text-core.scss";
export const TextCore = ({ text = "", color, fontSize = 14, fontWeight = "normal", textAlign = "left", textDecoration = "none", className, onClick, }) => {
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    // Check if the text is overflowing
    const checkOverflow = () => {
        if (textRef.current) {
            const { scrollWidth, clientWidth } = textRef.current;
            setIsOverflowing(scrollWidth > clientWidth);
        }
    };
    useEffect(() => {
        checkOverflow(); // Initial check
        // Set up ResizeObserver to observe changes to the textRef element
        const resizeObserver = new ResizeObserver(() => {
            checkOverflow();
        });
        if (textRef.current) {
            resizeObserver.observe(textRef.current);
        }
        return () => {
            if (textRef.current) {
                resizeObserver.unobserve(textRef.current); // Cleanup observer
            }
        };
    }, []);
    const style = {
        color,
        fontSize: `${fontSize}px`,
        fontWeight,
        textAlign,
        textDecoration,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        display: "block", // Ensure the element takes up space
    };
    return (_jsx(Tippy, { content: text, disabled: !isOverflowing, delay: [500, 0], children: _jsx("div", { className: classNameParserCore("poppins-regular", className), style: style, ref: textRef, onClick: onClick, children: text }) }));
};
